import { useTranslation } from "react-i18next";
import { useState } from "react";
import AuthModal from "src/components/Auth/AuthModal";
import { LoginButton, LoginLabel } from "./UserProfileSection.styled";
import { Container } from "../RegisterSection/RegisterSection.styled";

export const UserProfileSection = () => {
  const { t } = useTranslation(["affiliate"]);

  const [isLoginModalVisible, setIsLoginModalVisible] =
    useState<boolean>(false);

  return (
    <Container>
      <LoginButton
        type="primary"
        onClick={() => {
          setIsLoginModalVisible(true);
        }}
      >
        <LoginLabel>{t("affiliate:user.continue")}</LoginLabel>
      </LoginButton>
      <AuthModal
        visible={isLoginModalVisible}
        onClose={setIsLoginModalVisible}
      />
    </Container>
  );
};
